import { ReactNode } from 'react'
import { FlexRow } from '@/atoms/FlexContainers'
import { TitleMD, TitleSM } from '@/atoms/Text'

type HowItWorksCardProps = {
  index: number
  title: string
  description: ReactNode
}

export const HowItWorksCard = ({ index, title, description }: HowItWorksCardProps) => {
  return (
    <div className="w-full select-none gap-2 rounded-xl bg-white px-6 py-4 shadow-md lg:w-[361.33px]">
      <FlexRow className="gap-4">
        {/* eslint-disable-next-line tailwindcss/classnames-order */}
        <div className="bg-cool-01 flex h-8 w-8 items-center justify-center rounded-full">
          <TitleSM weight="semibold" color="white">
            {index + 1}
          </TitleSM>
        </div>
        <div className="flex h-6 shrink grow basis-0 items-center justify-between">
          <TitleMD weight="semibold">{title}</TitleMD>
        </div>
      </FlexRow>
      <div className="pt-4">{description}</div>
    </div>
  )
}
